import React from "react";

import Theme from "../theme/default";
import Header from "../header/header";
import BoiReactMarkdown from "../boi-markdown/boi-markdown";
import { Column, Flexbox } from "../theme/grid";
import { PageContainer } from "../theme/containers";

type DeprecatedBrowserProps = {
    help: React.Component | React.FunctionComponent | JSX.Element | string;
    browser: string;
};

const DeprecatedBrowser = ({
    help,
    browser
}: DeprecatedBrowserProps) => (
    <div className="App">
        <Theme>
            <Header helpScreen={help} />
            <Flexbox mx={["auto"]} width={"100%"}>
                <Flexbox
                    width={"100%"}
                    pb={["2rem", "2rem", "2rem", "2rem", "2rem", 0]}
                    mx={[0, 0, 0, 0, 0, 6]}
                    minHeight={"37.5rem"}
                >
                    <Column
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        backgroundColor="brilliant"
                        display="flex"
                        flexDirection="column"
                        className="formContent"
                        position="relative">
                        <PageContainer mx={"auto"}>
                            <BoiReactMarkdown className="u-text-centre">
                                {
                                    `# Unsupported browser\n\n` +
                                    `Bank of Ireland Application Centre no longer supports ${browser}.\n\n` +
                                    `If you are applying for a product or service, we recommend applying on your smartphone or tablet (it's quickest).\n\n` +
                                    `If you still want to apply here, you should switch to a modern alternative browser such as Microsoft Edge or Google Chrome.\n\n` +
                                    `Thank you`
                                }
                            </BoiReactMarkdown>
                        </PageContainer>
                    </Column>
                </Flexbox>
            </Flexbox>
        </Theme>
    </div>
);

export default DeprecatedBrowser;